var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "month-foot-card" }, [
      _c("div", [
        _vm._v(
          "\n    本月校园心理健康数据报告已全面呈现我校心理工作的推进成效与学生心理状态的趋势，印证了我校心理健康教育体系的扎实落地。这份成绩的背后，离不开学校对心理健康工作的高度重视，为学生构建了心理健康的\n    “防护网”，充分彰显了我校 “以生为本” 的教育理念与责任担当。\n  "
        ),
      ]),
      _c("div", [
        _vm._v(
          "\n    心灵的滋养需要耐心浇灌，成长的路上难免有风雨相伴，愿我们继续以爱为基、以智为翼，守护每一颗年轻心灵的澄澈与坚韧，让每一位学生都能在健康阳光的校园环境中，自信前行、向阳生长。\n  "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }